import "firebase/auth";
import { initializeApp, setLogLevel } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { doc, Firestore, getDoc, getFirestore, initializeFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";



// import { getAnalytics } from "firebase/analytics";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAuOEuZ98fwi18nzh8hipn7SC-Sdz9Fq6M",
  authDomain: "lot-number-9a1dc.firebaseapp.com",
//   databaseURL: "https://lot-number-9a1dc-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "lot-number-9a1dc",
  storageBucket: "lot-number-9a1dc.appspot.com",
  messagingSenderId: "163320429171",
  appId: "1:163320429171:web:53a4b2d91c01bfb08fc806",
  measurementId: "G-S74D4SQL0G"

};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

export const auth = getAuth(app);
export const db = getFirestore(app, 'continentalis-express');
export const storage = getStorage(app);
// export const provider = new GoogleAuthProvider();

// setLogLevel('debug')

export default app;

